<template>
  <DrinksBody />
</template>

<script>
import DrinksBody from '../molecules/DrinksBody.vue'


export default {
  name: 'DrinksView',
  components: {
    DrinksBody,
  }
}
</script>
